<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page row">
        <div class="form-item-rangedata"><RangeDataSelect :periodoInicial="'currentYear'" v-model="dateRange"/></div>

        <div v-if="globalStore.showSelectEstabelecimento" class="form-item">
            <div class="row">
                <div v-if="globalStore.showSelectSim" class="form-item">
                    <SimSelect :ckAddTodos="true" v-model:idSelecionado="idSim" />
                </div><div v-else class="form-item">
                    <label class="label-caption">SIM</label>
                    <div class="field-label">{{ globalStore.nmsim }}</div>
                </div>
                <EstabelecimentoSelect :ckAddTodos="true" class="form-item" v-model:idSelecionado="idEstabelecimento" />
            </div>


        </div><div v-else class="form-item">
            <label class="label-caption">Estabelecimento</label>
            <div class="field-label">{{ globalStore.nmestabelecimento }}</div>
        </div>

        <button type="button" class="buttom-icon--printer" @click="openReport" />
        <button type="button" class="buttom-icon--close" @click="closePage" />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import EstabelecimentoSelect from '../selects/EstabelecimentoSelect.vue';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import RangeDataSelect from '../selects/RangeDataSelect.vue';
import SimSelect from '../selects/SimSelect.vue';

const emit = defineEmits(['close']);
const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const msgAlerta = ref(null);
const idEstabelecimento = ref(0);
const idSim = ref(0);
const isLoading = ref(false);

const closePage = () => {emit('close');}

const openReport = async() => {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            nmrelatorio: 'coleta_nc_analitico',
            idep: globalStore.idep,
            idsim: globalStore.showSelectSim ? idSim.value : globalStore.idsim,
            idestabelecimento: globalStore.showSelectEstabelecimento ? idEstabelecimento.value : globalStore.idestabelecimento,
            idusuario: globalStore.idusuario,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate
        };
        const response = await Api.genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}
</script>